import { defineComponent as _defineComponent } from 'vue';
import { withModifiers as _withModifiers, normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, vShow as _vShow, withDirectives as _withDirectives, normalizeStyle as _normalizeStyle } from "vue";
const _hoisted_1 = { class: "flex-between" };
const _hoisted_2 = ["onClick"];
const _hoisted_3 = ["onClick"];
import { appShare, appPort, prevPageView } from '@/widget';
export default /*#__PURE__*/ _defineComponent({
    props: {
        shareInfo: {
            default: () => {
                return {};
            },
            type: Object
        },
        domStyle: {
            type: Object,
            default: () => {
                return {};
            }
        },
        color: {
            type: String,
            default: 'black'
        },
        pageTitle: {
            type: String,
            default: ''
        },
        share: {
            type: Boolean,
            default: true
        },
        titleColor: {
            type: String,
            default: ''
        }
    },
    setup(__props) {
        const props = __props;
        const isApp = appPort();
        const backFn = () => {
            if (isApp) {
                prevPageView();
            }
            else {
                history.go(-1);
            }
        };
        const shareFn = () => {
            // shareImgName, shareTitle, shareDescripttion
            let { desc, image, title, url } = props.shareInfo;
            appShare({
                url: url || location.href,
                desc,
                image,
                title
            });
        };
        return (_ctx, _cache) => {
            return (_openBlock(), _createElementBlock("div", {
                class: "appShareWrapper p-lr32 border-box",
                style: _normalizeStyle(__props.domStyle)
            }, [
                _createElementVNode("div", _hoisted_1, [
                    _createElementVNode("div", {
                        class: _normalizeClass(["backBtn", [`icon-left-${__props.color}`]]),
                        onClick: _withModifiers(backFn, ["stop"])
                    }, null, 10, _hoisted_2),
                    (__props.pageTitle)
                        ? (_openBlock(), _createElementBlock("div", {
                            key: 0,
                            class: _normalizeClass(["title font-32 text-overflow border-box p-lr20", [`${__props.titleColor}-color`]])
                        }, _toDisplayString(__props.pageTitle), 3))
                        : _createCommentVNode("", true),
                    _createElementVNode("div", null, [
                        _withDirectives(_createElementVNode("div", {
                            class: _normalizeClass(["shareBtn", [`icon-share-${__props.color}`]]),
                            onClick: _withModifiers(shareFn, ["stop"])
                        }, null, 10, _hoisted_3), [
                            [_vShow, __props.share]
                        ])
                    ])
                ])
            ], 4));
        };
    }
});
